export const MenusSistema = {
  mantenedor_area: {
    id: 'a6ef7645-d892-4780-9e71-15455c9383f5',
    accesos: {
      crear_editar_area: 'e28344a1-679d-4cb6-903d-f89dd3772969',
      crear_editar_tipo_area: '9c8ec13c-6e45-4d02-a652-6f54dd17b9dd',
    },
  },
  mantenedor_hito: {
    id: 'b73e6800-90ee-4f34-9716-90c9da658609',
    accesos: {
      crear_editar_grupo_hito: 'e06f1617-2ce4-477a-9953-c729f2c8800e',
      crear_editar_hito: 'cc2882a7-4b9d-49e8-a7f9-b89951382a20',
      remover_grupo_hito: '13fd092b-fc18-4a38-abf9-7c2286f37f54',
      remover_hito: 'bb652ef1-4ae5-44b3-ab6f-61b3663010ee',
    },
  },
  mantenedor_linea_gasto: {
    id: '89c13b87-0564-4c6a-b406-3b31fa89e961',
    accesos: {
      crear_linea_gasto: '0a07b884-3916-48fa-bbf2-0fe8feb135e1',
      remover_linea_gasto: '8c409419-a5a7-4c00-8856-7d10c736d832',
    },
  },
  mantenedor_tipo_documento: {
    id: '12c116e9-2f33-4473-944a-e4cb60900626',
    accesos: {
      crear_editar_tipo_documento: '2bccfb21-4839-4e8c-9972-c76f61300849',
      remover_tipo_documento: '0d3dbd86-8b20-466e-bc3d-037f7e821230',
    },
  },
  permisos_perfiles: {
    id: 'b9d20ea3-df43-4a75-b1f2-7416012dad1a',
    accesos: {
      crear_editar_perfil: 'a61a77a3-b267-4d09-ad13-e8f74595ee89',
    },
  },
  permisos_usuario: {
    id: '60f065ed-bc5a-4da5-9a3b-9c26c4a04a9d',
    accesos: {
      crear_editar_usuario: 'd0734fb2-1d5f-4067-83bf-8d587320ab0d',
      editar_areas_asignadas: '08dab8de-3a21-4f89-ab2d-d136b6f03ea6',
      editar_perfiles_asignados: 'e1a8ce0f-0d5d-4716-a218-5d5e6b3a324f',
      enviar_difucion: '4a2a42b5-27a4-4de1-8289-c45eabe7bb0c',
    },
  },
  presupuesto_asignado: {
    id: '1c1a52e0-b315-4287-8a0e-a4dd5f8edd80',
    accesos: {
      aprobar_presupuesto: '36c75141-8486-4403-b4fe-31ab4a8f465d',
      asignar_linea_gasto: 'ffe1da50-ffce-478d-aeb9-f62061088280',
      ingresar_movimiento_egreso: 'ee5a5385-0cea-46f0-bf22-d64ccb43a852',
      redistribuir_montos: '6bbe3713-57fb-41db-a9a6-369a7cfaf0d5',
    },
  },
  presupuesto_listado: {
    id: 'cc8dfa29-4207-474a-a4a4-f3cd448775a7',
    accesos: {
      crear_editar_presupuesto: '28007a66-849b-4e15-9cf0-268b19ce715e',
      ver_bitacora: '53bb171f-af72-4375-8169-e0113dad7fa7',
      ver_resumen: '2e6fb616-8a49-4e8d-bc09-8efaf40de4c9',
    },
  },
  proyecto_gestion: {
    id: '2bd20812-bcd7-4b39-8189-c6d389370aea',
    accesos: {
      editar_hito: 'ccc54bbc-8d72-40b7-8ba4-01614badf587',
      ver_bitacora: '49064697-e56b-4ec0-b364-04b66bc288fc',
    },
  },
  proyecto_trato: {
    id: 'd905733f-cd49-4227-a218-6fcef7eebb9f',
    accesos: {
      generar_proyecto: '852e7db8-f5ef-4fae-9046-ba566974c7e5',
      modificar_trato: '3ec82f92-e9fb-4bf0-acbb-a24bfa527d30',
    },
  },
  reporte_dashboard: {
    id: 'c50e29e3-8286-40cc-83fd-da20fcdc567f',
    accesos: {
      ver_reporte: 'a8bee719-a458-4602-8948-c6bd9217116d',
    },
  },
  configuracion_notificacion: {
    id: '894ad1fc-77f9-4b0f-ac03-63726536dec6',
    accesos: {
      crear_editar_tipo_notificacion: 'a64c84fb-6888-4b9f-b755-370a9684f343',
      remover_tipo_notificacion: 'f5d32713-c8c2-4bf7-9108-ab3b06ff39ee',
    },
  },
  mantenedor_snc: {
    id: '9fd1bc07-10e3-4149-ad28-c15a85ccefeb',
    accesos: {
      activa_desactiva_snc: 'e6021cb2-e9ec-4eee-aa1c-b069503906ee',
      crear_editar_snc: '9ac47416-0a18-4873-ab00-3f76043205c4',
      listar_snc_activas: 'de5a1554-c0b2-4693-bd81-6b580cd6b36a',
    },
  },
  salidas_no_conformes: {
    id: '6d0b43af-7646-4363-83d9-cc157e2e3239',
    accesos: {
      crear_editar_salida_no_conforme: '6863b784-e2a4-4140-8bc1-8e693ecd78f4',
      listar_salidas_no_conformes: '4d147477-f535-4448-8c10-563befdbf21e',
    },
  },
  configuracion_mensajeria: {
    id: '5e7ff192-40c4-42ce-a312-5eb9dec95658',
    accesos: {
      activa_desactiva_mensajeria: '08e631cd-7546-4968-b113-8c900922a7f8',
      listar_usuarios_para_mensajeria: 'ae94b615-b90a-4a35-b74c-9500e6bda576',
    },
  },
  checklist: {
    id: '4400dc6e-055a-4373-8041-34cc571bde00',
    accesos: {
      gestionar: '4400dc6e-055a-4373-8041-34cc571bde01',
    },
  },
}
